import axiosInstance from "@API/axios";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";
import { useNavigate } from "react-router";
import { home } from "../AppRoutes/DefaultRoutes";
const useGetItem = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getItem = (url, id) => {
    return axiosInstance
      .get(`${url}/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        const status = error.response?.status;

        if (status === 404) {
          dispatch(
            setSnackbar({
              open: true,
              message: "The item is not found",
              error: true,
            })
          );
        } else if (status === 401 || status === 403) {
          dispatch(
            setSnackbar({
              open: true,
              message: "Unauthorized access!",
              error: true,
            })
          );
          navigate(home);
          return null;
        } else {
          const data = error.response?.data;
          const errorMessage =
            typeof data === "object"
              ? data?.details || "Unexpected error occurred."
              : typeof data === "string"
              ? data
              : "Internal Server Error.";

          dispatch(
            setSnackbar({
              open: true,
              message: errorMessage,
              error: true,
            })
          );
        }
      });
  };
  return getItem;
};

export default useGetItem;
